import React from "react";
import _ from "lodash";
import userImg from "../../../assets/images/bingo/user-img.png";
import pauseBtn from "../../../assets/images/bingo/pause-btn.png";
import { Col, Container, Row } from "reactstrap";

const BingoGameOver = ({ on_start_bingo, winnerUsers, paramsReducerr, badBingoUsers, onTimesUp, on_play_again }) => {
  const parameters = _.get(paramsReducerr, "6_over");

  return (
    <>
      <Container>
        <Row>
          <Col xl={8} lg={8}>
            <div className="bingo-game-over-modal">
              <div className="bingo-game-over-dialog">
                <div className="bingo-game-over-content">
                  {/* <h2 className="game-over-text">{parameters?.game_over}</h2> */}
                  {winnerUsers.length > 1 ? (
                    <h4 className="winners">{parameters?.winners}</h4>
                  ) : (
                    <h4 className="winners">{parameters?.winner}</h4>
                  )}
                  <div className="bingo-winners">
                    {winnerUsers &&
                      winnerUsers.length > 1 &&
                      winnerUsers.map((user) => (
                        <div className="winner-list">
                          <img src={user.profile_image} alt="player" />
                          <p className="winner-name">{user.display_name}</p>
                        </div>
                      ))}
                    {winnerUsers &&
                      winnerUsers.length === 1 &&
                      winnerUsers.map((user) => (
                        <div className="single-winner-list">
                          <img src={user.profile_image} className="single-winner-img" alt="player" />
                          <p className="single-winner-name">{user.display_name}</p>
                        </div>
                      ))}
                  </div>
                  {badBingoUsers.length > 0 && (
                    <div className="bad-bingos">
                      <h4>{parameters?.bad_bingos}</h4>
                      <div className="bad-bingos-box">
                        {badBingoUsers &&
                          badBingoUsers.length > 0 &&
                          badBingoUsers.map((user) => (
                            <ul>
                              <li>{user.display_name}</li>
                            </ul>
                          ))}
                        {/* {badBingoUsers &&
                        badBingoUsers.length <= 1 &&
                        badBingoUsers.map((user) => (
                          <ul>
                            <li>{user.display_name}</li>
                          </ul>
                        ))} */}
                      </div>
                    </div>
                  )}
                  <div className="text-center mt-2 mb-2">
                    <button onClick={on_play_again} className="play-again-btn">
                      {parameters?.play_again}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};
export default BingoGameOver;
